import React from "react";

import Logo from './logo.png';
import PermisosLogo from './tu-permiso-rapido-facil.svg';

import { withStyles } from "@mui/styles";
import { withRouter } from "react-router-dom";
// import withRouter  from 'adds/router/withRouter.js';

import {
  Paper,
  Box,
  Container,
  Typography,
  Grid,

} from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

const useStyles = theme => ({
  root: {
    //background: 'linear-gradient(to top left, #FF7043, #2E7D32)',
    background: 'linear-gradient(to top left, #70AEFF, #7AAD5A)',
    heigth: "100vh",
  },
  logo: {
    maxHeight: 120,
    maxWidth: 300,
    paddingLeft: 'auto',
    paddingTop: '1rem',
  },
  permisosLogo: {
    maxHeight: 150,
    maxWidth: 300,
    paddingLeft: 'auto',
    paddingTop: 'auto'
  },
  content: {
    maxWidth: 1000,
  },
  container: {
    paddingTop: 1,
    paddingBottom: 2,
  },
  paper: {
    padding: 2,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },

});

class PublicLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };


  }
  render() {
    return (
      <Box className={this.props.classes.root}>
        <CssBaseline />
        <Box display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <Paper elevation={3}>
            <Container component="main" maxWidth="md">
              <Box p={2} className={this.props.classes.content}>
                <Grid container >
                  <Grid item xs={6} align='center'>
                    <img src={Logo} alt='Renca' className={this.props.classes.logo} />
                  </Grid>
                  <Grid item xs={6} align='center'>
                    <img src={PermisosLogo} alt='Renca' className={this.props.classes.permisosLogo} />
                  </Grid>
                </Grid>
              </Box>
              <Box>
                {this.props.children}
              </Box>

            </Container>
          </Paper>
        </Box>

      </Box>
    );
  }
}

export default withRouter(withStyles(useStyles, { withTheme: true })(PublicLayout));
